export default "__VITE_ASSET__DaT82ZC___"